const baseUrl_devTesting = 'http://store-gcp-sarthak.classplus.co';
const baseUrl_preprod = 'https://apip-preprod.classplusapp.com';
// const baseUrl_preprod = 'http://172.16.9.223:8083';
const baseUrl_prod = 'https://api.classplusapp.com';
const baseUrl_preprodTest = 'https://store-preprod-test.classplus.co';

//Change only this url
const baseURLGlobal = baseUrl_preprod;

export default baseURLGlobal;
